<template>
  <VSection label="autotopupregistrations.transactions_headline">
    <VueGoodTable v-bind="table">
      <template v-if="hasAccessRechargeTransactions" #table-row-after="{ row, index }">
        <td>
          <VButton
            v-if="row.transactionId"
            class="btn-default btn-small"
            label="autotopupregistrations.details_button_label"
            @click.stop="showRecharchingTransaction(row, index)"
          />
        </td>
      </template>
      <template #table-column="{ column }">
        <VTableHeader :columns="table.columns" :column="column" />
      </template>
    </VueGoodTable>
  </VSection>
</template>

<script>
import selectListColumns from './selectListColumns';
import VSection from '@/components/Section';
import { formatDateTime } from '@/utils/date';
import TableMixin from '@/mixins/table';
import TableUtilitiesMixin from '@/mixins/tableUtilities';
import { VueGoodTable } from 'vue-good-table';
import VTableHeader from '@/components/Table/Header';
import VButton from '@/components/Button';
import { RECHARGE_TRANSACTIONS_OVERVIEW_DETAILS } from '@/router/route-types';
import { mapGetters } from 'vuex';

export default {
  name: 'AutoTopUpRegistrationDetailsTransactions',

  components: {
    VSection,
    VueGoodTable,
    VTableHeader,
    VButton,
  },

  mixins: [TableMixin, TableUtilitiesMixin],

  props: {
    transactions: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: {
        columns: selectListColumns,
        rows: null,
        defaultSortBy: { field: 'transactionId', type: 'desc' },
        onClick: null,
      },
    };
  },

  computed: {
    ...mapGetters('system', ['hasAccessRechargeTransactions']),
  },

  created() {
    this.table.columns.find(c => c.action).hidden = !this.hasAccessRechargeTransactions;
    this.table.rows = this.translateRows(this.transactions);
  },

  methods: {
    translateRows(rows) {
      return rows.map(oldRow => {
        const row = Object.assign({}, oldRow);
        row.transactionId = row.transactionId?.toString();
        row.topUpDatetime = formatDateTime(row.topUpDatetime);
        row.status = this.$t(`autotopupregistrations.transaction_status_${row.status}`);
        return row;
      });
    },

    showRecharchingTransaction(row) {
      this.$router.push({
        name: RECHARGE_TRANSACTIONS_OVERVIEW_DETAILS,
        params: { transactionId: row.transactionId },
      });
    },
  },
};
</script>
